<template>
  <div id="about">
    <div class="about_banner" v-cloak></div>
    <div class="about_profile" id="a">
      <div class="title">企业简介</div>
      <div class="about_profileText">
        <br>
        浙江安宣信息技术有限公司，是集软件定制开发、物联网智能设备研发、互联网运营及人才培养为一体的国家高新技术企业。公司主要提供农副产品及食品质量安全追溯解决方案、银行聚合支付行业应用解决方案，创新运用互联网、大数据、人工智能等现代信息技术为客户创造价值，致力于成为专业的产品追溯技术服务商、聚合支付行业应用服务商、软件定制开发服务商。
        <br><br>
        公司以助力政府和企业实现产品质量安全全程可溯为使命。多年来，公司承建了“浙江省食品电子监管系统”、浙江省市场食用农产品质量安全追溯系统”、“浙江省预包装食品电子台账追溯系统”、“丽水市食用农产品溯源系统”、“衢州市食品安全全程追溯系统”等项目。
        <br><br> 公司以助力银行拓展聚合支付应用场景为己任，与40多家银行合作研发了“农产品电子追溯+智慧支付系统”，在浙江省各地区100多个农贸及农批市场投入使用，并凭借多模式、高效率、低成本之优势得到了用户的广泛认同。
        <br><br> 公司运用互联网技术实现让产品安全可追溯，竭诚为客户提供定制化产品、个性化方案以及专业化服务。公司本部位于杭州西湖科技园，在浙江11个地市设立了办事处，业务范围遍及浙江全省。
      </div>
    </div>
    <!-- 企业优势 -->
    <div class="about_advantage" id="b">
      <div class="title">企业优势</div>
      <div class="about_advantageLists">
        <div v-for="(item,index) in advantages" class="about_advantageList">
          <img v-lazy="item.img">
          <div class="mask"></div>
          <p>{{ item.text1 }}</p>
          <p>{{ item.text2 }}</p>
        </div>
      </div>
    </div>
    <!-- 资质荣誉 -->
    <div class="aboud_honour" id="c">
      <div class="title">资质荣誉</div>
      <div class="honourBanner swiper-container" id="honourBanner">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in certificates">
            <div class="honourLists">
              <div class="honourList" v-for="(item_,index_) in item">
                <img :src="item_.url">
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
    <!-- 企业特色 -->
    <div class="about_characteristics" id="d">
      <div class="title">企业特色</div>
      <img src="http://img.anxuan360.com/FmtPx9rsCGxx3bExVNE_MU3d2hko" class="about_characteristicsBG">
      <div v-for="(item,index) in characteristics" class="about_characteristic"
           :class="index==0?'ball1':index==1?'ball2':index==2?'ball3':'ball4'">
        <div class="about_characteristic_content">
          <p class="c_title">{{ item.title }}</p>
          <p class="c_text">{{ item.text1 }}</p>
          <p class="c_text">{{ item.text2 }}</p>
          <p class="c_text">{{ item.text3 }}</p>
          <p class="c_text">{{ item.text4 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'

export default {
  metaInfo() {
    return {
      meta: [{
        name: 'renderer',
        content: 'http://www.ax168.com/about'
      },
        {
          name: 'about',
          content: '关于我们、企业简介、企业优势、资质荣誉、企业特色'
        },
        {
          name: 'keywords',
          content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
        },
        {
          name: 'description',
          content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
        }
      ]
    }
  },
  data() {
    return {
      Seo: '关于我们,http://www.ax168.com/about',
      advantages: [{
        img: 'http://img.anxuan360.com/FhPcKV7DSutaQyTu742qgUBufdII',
        text1: '十年技术沉淀',
        text2: '专业技术团队',
      }, {
        img: 'http://img.anxuan360.com/FkH9zEtdKY0uPuv8LWqnU49AvDEc',
        text1: '国家级高新技术企业',
        text2: '通过双软认证',
      }, {
        img: 'http://img.anxuan360.com/Fmy6E87oLy4Na9jB6Mug3gW_4EQT',
        text1: '产品体系完整',
        text2: '拥有数十项专利及软件著作权证书',
      },],
      certificates: [
        [{
          url: 'http://img.anxuan360.com/FmEFzF4LRpuluCXlJNZD5_EpI7TU'
        },
          {
            url: 'http://img.anxuan360.com/Fm5iAPWCOteYoP7HoZTa_fP6VTg-'
          },
          {
            url: 'http://img.anxuan360.com/FoZMY15dBBJwTfPYCw-_4cEk-CHb'
          },
          {
            url: 'http://img.anxuan360.com/FiEeWjakzMdIqyEXYBmZ3A6RYG_p'
          },
        ],
        [{
          url: 'http://img.anxuan360.com/FpoiqpEoUf7Ya5AAVHW1sQgE9u8G'
        },
          {
            url: 'http://img.anxuan360.com/FmEFzF4LRpuluCXlJNZD5_EpI7TU'
          },
          {
            url: 'http://img.anxuan360.com/FnhRHhMmYP5EqqVaNYjI-9ksTYjv'
          },
          {
            url: 'http://img.anxuan360.com/FlrvNQswAHbWdc0x4LwtT0SDqgSe'
          },
        ],
        [{
          url: 'http://img.anxuan360.com/FhhbRV4o22OyOf1b6Dhe_y-QSjtB'
        },
          {
            url: 'http://img.anxuan360.com/FgGvav2wTy55H2102qkWnUox-41r'
          },
          {
            url: 'http://img.anxuan360.com/FpY4QUwF7NkbWUiDeMTwz9y7UQvx'
          },
          {
            url: 'http://img.anxuan360.com/Fuh1gNslmt-eRPnaGmAjD95JGOay'
          },
        ],
        [{
          url: 'http://img.anxuan360.com/Fj-FoL7VA9pCRxqh4KhfGLGhg39T'
        },
          {
            url: 'http://img.anxuan360.com/Fv5JsT2UaTAOwll0_TMOPIwXFulj'
          },
          {
            url: 'http://img.anxuan360.com/FntjPNZR8TRf9-rpwlJGUzMzl8Q-'
          },
          {
            url: 'http://img.anxuan360.com/FlyXyaqkSlYLggrxZgSe9h1FUDDg'
          },
        ],
        [{
          url: 'http://img.anxuan360.com/FsJ-pwUR7aWcLnZh_m7oyxxCLwgo'
        },
          {
            url: 'http://img.anxuan360.com/FmPLLBVXeC6q0q234fkri-ISi5_j'
          },
          {
            url: 'http://img.anxuan360.com/FnXCQykKbVgmLbFD-h_B1q8K6OMZ'
          },
          {
            url: 'http://img.anxuan360.com/Fo7zIyYhI1Oo2HTtdeT-WsDJd4r3'
          },
        ],
        [{
          url: 'http://img.anxuan360.com/Fj4o9ONUEpwwWKaEcu1N9wFQK-VC'
        },
          {
            url: 'http://img.anxuan360.com/Fub0c1RfGeFYIlI0A4n7YAz7eJ9K'
          },
          {
            url: 'http://img.anxuan360.com/Fr3Luanav8jND6j1M66qQxjvfSSR'
          },
          {
            url: 'http://img.anxuan360.com/Fg87i_F7vW7ceNsxLsjivRT-CssI'
          },
        ],
        [{
          url: 'http://img.anxuan360.com/Fga4apt4x7IeID4T4abXVjst3MvS'
        },
          {
            url: 'http://img.anxuan360.com/Fiqg8OIYiEfVLAuEBIQMSBGHyEX1'
          },
          {
            url: 'http://img.anxuan360.com/Fuz3RgvPLY1P992KqBwRDAOaP-JF'
          },
          {
            url: 'http://img.anxuan360.com/FvY7eeONCvP81gU2saudLqh3gANU'
          },
        ]
      ],
      characteristics: [{
        title: '产品定制及综合解决方案',
        text1: '农产品追溯解决方案',
        text2: '物联网监控系统',
        text3: '追溯产品质量保证',
        text4: '',
      }, {
        title: '专业技术，高效响应',
        text1: '专业化研发团队',
        text2: '在产品创新研发、软件开发实施',
        text3: '系统维护服务等方面',
        text4: '具有专业实力和竞争优势',
      }, {
        title: '安全理念，节点保障',
        text1: '系统安全、软件安全',
        text2: '资金安全、交易安全',
        text3: '存储安全、服务器安全',
        text4: '',
      }, {
        title: '一站式贴心服务',
        text1: '强大的售前售后团队',
        text2: '高效率沟通对接',
        text3: '及时迅速响应服务',
        text4: '全方位技术指导',
      },],
    }
  },
  methods: {
    handNavGx() {
      window.open("https://beian.miit.gov.cn", '_blank')
    },
  },
  components: {},
  activated() {
    document.documentElement.style.fontSize = "";
//
//			//banner轮播
//			var swiper = new Swiper('.honourBanner', {
//				speed: 3000,
//				autoplay: 2000,
//				autoplayDisableOnInteraction: false,
//				loop: true,
//				nextButton: '.honourBanner .swiper-button-next',
//				prevButton: '.honourBanner .swiper-button-prev',
//			});


  },
  mounted() {
    this.$nextTick(() => {

      var comtainer = document.getElementById('honourBanner');

      var swiper = new Swiper('.honourBanner', {
        speed: 3000,
        autoplay: 2000,
        autoplayDisableOnInteraction: false,
        loop: true,
        nextButton: '.honourBanner .swiper-button-next',
        prevButton: '.honourBanner .swiper-button-prev',
      });
      comtainer.onmouseenter = function () {
        swiper.stopAutoplay();
      };
      // 鼠标离开 继续轮播
      comtainer.onmouseleave = function () {
        swiper.startAutoplay();
      }

    })

  },

}
</script>

<style scoped="scoped">
@import url('../css/about.css');

[v-cloak] {
  display: none !important;
}

.about_profileText {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue